"use strict";
// @ts-nocheck
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRef = exports.getRef = exports.makeNodesUnreachable = exports.makeNodesReachable = exports.performOperationOnNodeList = exports.makeNodeUnreachable = exports.makeNodeReachable = exports.selectAllElementsWithSelectors = exports.getNodeAttributes = exports.setNodeAttributes = exports.removeNodeAttributes = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var lodash_1 = require("lodash");
/*
  This is a safe wrapper around the native node.removeAttribute
  method. Makes possible passing an array of attributes to remove.
*/
exports.removeNodeAttributes = function (node, attributes) {
    attributes.forEach(function (attribute) {
        if (node && typeof node.removeAttribute === 'function') {
            node.removeAttribute(attribute);
        }
    });
};
/*
  This is a safe setter/wrapper around the native node.setAttribute
  method. Makes possible passing an object of keys (attributes) and
  their values to make setting multiple attributes easier.
*/
exports.setNodeAttributes = function (node, attributes) {
    Object.keys(attributes).forEach(function (attribute) {
        if (node && typeof node.setAttribute === 'function') {
            node.setAttribute(attribute, attributes[attribute]);
        }
    });
};
/*
  This is a safe-getter/wrapper around the native `node.getAttribute` function.
  Returns the attributes in a object.
*/
exports.getNodeAttributes = function (node, attributes) {
    return attributes.reduce(function (resultsObject, attribute) {
        if (node && typeof node.getAttribute === 'function') {
            resultsObject[attribute] = node.getAttribute(attribute);
        }
        return resultsObject;
    }, {});
};
/*
  A util for taking in an array of selectors such as ['div.some-class', 'div#some-id'],
  selecting those elements via `querySelectorAll`
  and returning those nodes in an array.
*/
exports.selectAllElementsWithSelectors = function (selectors) {
    return selectors.reduce(function (nodes, selector) {
        return __spread(nodes, document.querySelectorAll(selector));
    }, []);
};
/*
  This function undoes the work that makNodeUnreachable does
  to make the node reachable again via tab and screen readers.
  It will remove the tabindex="-1" and aria-hidden="true" attributes,
  take the previous tabindex and aria-hidden attributes
  stored in the data-previous- prefixed attributes,
  apply those previous values and finally remove the data-previous attributes.
*/
exports.makeNodeReachable = function (node) {
    var previousAttributes = [
        'data-previous-tabindex',
        'data-previous-aria-hidden',
    ];
    var attributes = exports.getNodeAttributes(node, previousAttributes);
    var previousTabIndex = attributes['data-previous-tabindex'];
    var previousAriaHidden = attributes['data-previous-aria-hidden'];
    exports.removeNodeAttributes(node, ['tabindex', 'aria-hidden']);
    if (previousTabIndex) {
        exports.setNodeAttributes(node, { tabindex: previousTabIndex });
    }
    if (previousAriaHidden) {
        exports.setNodeAttributes(node, { 'aria-hidden': previousAriaHidden });
    }
    exports.removeNodeAttributes(node, previousAttributes);
};
/*
  This util stores the existing tabindex and aria-hidden attributes
  in data-previous- prefixed values and then sets the tabindex to -1
  and the aria-hidden to true. This should keep the element out of
  the tab order and hide it from screen readers, and will allow us
  to reset the tabindex to aria-hidden to the previous value when done.
*/
exports.makeNodeUnreachable = function (node) {
    var attributes = exports.getNodeAttributes(node, ['tabindex', 'aria-hidden']);
    var existingTabIndex = attributes.tabindex;
    var existingAriaHidden = attributes['aria-hidden'];
    if (existingTabIndex) {
        exports.setNodeAttributes(node, {
            'data-previous-tabindex': existingTabIndex,
        });
    }
    if (existingAriaHidden) {
        exports.setNodeAttributes(node, {
            'data-previous-aria-hidden': existingAriaHidden,
        });
    }
    exports.setNodeAttributes(node, { tabindex: '-1', 'aria-hidden': true });
};
/*
  This is a util to make performing an operation on a node list easier.
  It recursively performs an operation on its node, and if the node has children,
  it will drill down and perform the operation on the children as well,
  until there are no more children.
*/
exports.performOperationOnNodeList = function (operation, nodeList) {
    /*
      Spreading the nodeList is necessary because when selecting
      items from the DOM via querySelectorAll, a nodeList is returned,
      which is like an array but is not iterable.
      This transforms the list into an iterable array.
    */
    var nodeArray = __spread(nodeList);
    nodeArray.forEach(function (node) {
        operation(node);
        if (node && node.childNodes) {
            var childArray = __spread(node.childNodes);
            exports.performOperationOnNodeList(operation, childArray);
        }
    });
};
exports.makeNodesReachable = lodash_1.partial(exports.performOperationOnNodeList, exports.makeNodeReachable);
exports.makeNodesUnreachable = lodash_1.partial(exports.performOperationOnNodeList, exports.makeNodeUnreachable);
exports.getRef = function (Component, key) {
    // Regardless of whether the ref is a real DOM node or a component,
    // always return the representative DOM node.
    var ref = lodash_1.get(Component, ['dangerousRefs', key]);
    return react_dom_1.default.findDOMNode(ref);
};
exports.setRef = function (Component, key) { return function (nodeOrComponent) {
    // The ref might be a real DOM node _or_ a representation of a component
    lodash_1.set(Component, ['dangerousRefs', key], nodeOrComponent);
}; };
